import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { ValueConfPageDto, ValueConfPagesDto } from '../models/ValueConfPage';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class ValueConfPageService extends BaseService {
 

  constructor(private httpClient: HttpClient, private oauthService: OAuthServiceService) {
    super();
  }

  getValueConfPage(id: string, dbname: string): Observable<ValueConfPageDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<ValueConfPageDto>(`${this.valueConfPage}/${id}`, { headers: headers });
  }

  loadValueConfPages(serachText: string, docStereoTypeId: string, page: number, pageSize: number, dbname: string): Observable<ValueConfPagesDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<ValueConfPagesDto>(`${this.valueConfPage}?searchText=${serachText}&docStereoTypeId=${docStereoTypeId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  getValueConfPages(docStereoTypeId: string, dbname: string, genericFilter: GenericFilter) : Observable<ValueConfPageDto[]> {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${this.oauthService.token}`)
    .set('dbname', dbname);
  return this.httpClient.post<ValueConfPageDto[]>(`${this.valueConfPage}/${docStereoTypeId}/GetFilteredValueConfPages`, genericFilter, { headers: headers });
  }

  createValueConfPage(valueConfPageDto: ValueConfPageDto, dbname: string): Observable<ValueConfPageDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<ValueConfPageDto>(`${this.valueConfPage}`, valueConfPageDto, { headers: headers });
  }

  updateValueConfPage(valueConfPageDto: ValueConfPageDto, dbname: string): Observable<ValueConfPageDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<ValueConfPageDto>(`${this.valueConfPage}/${valueConfPageDto.id}`, valueConfPageDto, { headers: headers });
  }

  deleteValueConfPage(valueConfPageDto: ValueConfPageDto, dbname: string): Observable<ValueConfPageDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<ValueConfPageDto>(`${this.valueConfPage}/${valueConfPageDto.id}`, { headers: headers });
  }
}
